'use client';

import { cn } from '@/lib/utils';

import { LocationFilter } from './location-filter';
import { SkillsFilter } from './skills-filter';
import { StatusFilter } from './status-filter';

type FiltersContentProps = {
  className?: string;
  variant: 'mobile' | 'desktop';
};

export const FiltersContent = ({ className, variant }: FiltersContentProps) => {
  return (
    <div className={cn('overflow-y-auto', className)}>
      <LocationFilter variant={variant} defaultOpen />
      <SkillsFilter defaultOpen />
      <StatusFilter defaultOpen />
    </div>
  );
};
